import { GoogleMap, useJsApiLoader, Marker, Polyline } from '@react-google-maps/api';
import React, { useEffect, useState } from 'react';
import { useFetch } from '../../../../biz/hooks/data/useFetcher';
import { IGeoCodeResponse } from './useGeoCode';
import { TypeOfBusinessType } from '../../../../biz/data/redux/organizationReducer';

export type LatLng = { latitude: number, longitude: number }
export type MapBounds = { latitudeMax: number, latitudeMin: number, longitudeMax: number, longitudeMin: number }

const googleMapsApiKey = "AIzaSyBAqFqA8wZ96CN3p53TZ9MoQ_cIOizU8BQ";
const defaultLocation = { lat: 61.40942379537279, lng: 15.655752434936518 };
const startValue: LatLng = { latitude: defaultLocation.lat, longitude: defaultLocation.lng };

export const MapSmall = ({ value = startValue, onChange, geocodeResponse, onClearGeocodeResponse, typeOfBusiness }: { value?: LatLng, onChange?(e: LatLng): void, geocodeResponse?: IGeoCodeResponse, onClearGeocodeResponse?(): void, typeOfBusiness: TypeOfBusinessType }) => {

    const useValue = Math.abs(value?.latitude) * Math.abs(value?.longitude) > 0;

    const containerStyle: React.CSSProperties = { width: '100%', height: '100%', borderRadius: "16px" };

    const { isLoaded } = useJsApiLoader({ id: 'google-map-script', googleMapsApiKey: googleMapsApiKey })
    const [map, setMap] = React.useState<google.maps.Map | null>(null);

    const onLoad = React.useCallback((map: google.maps.Map) => {
        map.panTo(useValue ? { lat: value?.latitude, lng: value?.longitude } : defaultLocation);
        map.setZoom(useValue ? 11 : 5);
        setMap(map)
    }, [])
    const onUnmount = React.useCallback((map: any) => { setMap(null) }, []);

    const [hideMarkers, setHideMarkers] = useState<boolean>(false);

    useEffect(() => {
        if (geocodeResponse && geocodeResponse.results?.length > 1) {
            const markers = geocodeResponse.results.map(p => new google.maps.LatLng(p?.geometry?.location?.lat, p?.geometry?.location?.lng))
            var bounds = new google.maps.LatLngBounds();
            markers.forEach(m => {
                bounds.extend(m);
            });
            map?.fitBounds(bounds);
            setHideMarkers(false);
        }
        if (geocodeResponse && geocodeResponse.results?.length == 1) {
            var lat = geocodeResponse.results?.[0]?.geometry.location?.lat;
            var lng = geocodeResponse.results?.[0]?.geometry.location?.lng;
            if (onChange) {
                onChange({ latitude: lat ?? 0, longitude: lng ?? 0 });
            }
            map?.setZoom(11);
            map?.setCenter(geocodeResponse.results?.[0]?.geometry.location);
            setHideMarkers(true);
        }
    }, [geocodeResponse])


    return (
        <div className='profile-map-container'>
            {isLoaded && (
                <GoogleMap mapContainerStyle={containerStyle}
                    center={useValue ? { lat: value?.latitude, lng: value?.longitude } : defaultLocation}
                    zoom={20}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                    options={{
                        streetViewControl: false,
                        rotateControl: false,
                    }}
                    onBoundsChanged={() => {
                        // const b = map?.getBounds();
                        // // MapHelper.convertBounds(b);
                        // // setLastCenter(map.getCenter())
                    }}
                >
                    {/* Marker */}
                    <Marker
                        position={useValue ? { lat: value?.latitude, lng: value?.longitude } : defaultLocation}
                        title="Edit"
                        draggable={true}
                        onDragEnd={e => {
                            if (e != null && e.latLng != null) {
                                if (!!onChange) {
                                    onChange({ latitude: e.latLng.lat(), longitude: e.latLng.lng() })
                                }
                            }
                        }}
                        icon={{
                            url: typeOfBusiness == "plants_and_garden" ? require("../../../gfx/organizationtype-plants_and_garden.svg").default :
                                typeOfBusiness == "services" ? require("../../../gfx/organizationtype-services.svg").default :
                                    typeOfBusiness == "local_growers" ? require("../../../gfx/organizationtype-local_growers.svg").default :
                                        require("../../../gfx/organizationtype-misc.svg").default
                        }}
                    />

                    {/* Searches */}
                    {(!!geocodeResponse && hideMarkers !== true) && geocodeResponse?.results?.map(pos => (
                        <Marker
                            position={pos?.geometry?.location}
                            title={pos?.formatted_address}
                            draggable={true}
                            onDragEnd={e => {
                                if (e != null && e.latLng != null) {
                                    console.log({ latitude: e.latLng.lat(), longitude: e.latLng.lng() });
                                    if (!!onChange) {
                                        onChange({ latitude: e.latLng.lat(), longitude: e.latLng.lng() });
                                        if (!!onClearGeocodeResponse) { onClearGeocodeResponse() }
                                    }
                                }
                            }}
                            onClick={() => {
                                console.log(pos?.formatted_address)
                            }}
                        //icon={{ url: require("../../../gfx/organizationtype-misc.svg").default, }}
                        />
                    ))}
                </GoogleMap>

            )}
            {/* <div>
                {value?.latitude} | {value?.longitude}
            </div> */}

        </div>
    )


}
